import { render, staticRenderFns } from "./PropertyDocuments.vue?vue&type=template&id=47da2b39&"
import script from "./PropertyDocuments.vue?vue&type=script&lang=js&"
export * from "./PropertyDocuments.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports